function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { transition } from '../../utils/styleUtils';
import { createStyles } from '../../utils/styleUtils/createStyles';
import { getSpace } from '../../utils/styleUtils/space';
export const useStyles = createStyles((theme, params)=>{
    const isStriped = params.appearance === 'striped';
    const isGrouped = params.kind === 'grouped';
    const oddOrEven = params.kind === 'primary' ? 'even' : 'odd';
    return {
        root: _object_spread({
            label: 'Table-root'
        }, params.scrollable && {
            overflow: 'auto'
        }),
        table: _object_spread(_object_spread_props(_object_spread(_object_spread_props(_object_spread(_object_spread_props(_object_spread({
            label: 'Table-table',
            width: '100%',
            borderCollapse: isGrouped ? 'separate' : 'collapse'
        }, isGrouped && {
            overflow: 'hidden'
        }), {
            emptyCells: 'show',
            position: 'relative'
        }), params.fixedLayout && {
            tableLayout: 'fixed'
        }, params.withSeparateRows && {
            borderCollapse: 'separate',
            borderSpacing: `0 ${theme.space.s}px`
        }), {
            // table cells and header cells
            ['& td, & th']: _object_spread({
                padding: params.size === 'm' ? theme.space.m : `${theme.space.sm}px ${theme.space.m}px`,
                color: theme.color.textPrimary,
                lineHeight: theme.textLineHeight.m,
                backgroundColor: theme.color.backgroundPrimary,
                ['&:first-of-type']: {
                    paddingLeft: getSpace(params.insetPaddingX, theme)
                },
                ['&:last-of-type']: {
                    paddingRight: getSpace(params.insetPaddingX, theme)
                },
                ['&[data-highlighted=true]']: {
                    backgroundColor: theme.color.backgroundSecondary
                },
                // styling for table cell kinds
                ['&[data-kind=heading]']: {
                    fontSize: theme.textSize.m,
                    color: theme.color.textPrimary,
                    textTransform: 'none'
                },
                ['&[data-kind=descriptive]']: {
                    color: theme.color.textSecondary
                },
                // handle sticky cells
                ['&[data-sticky=true]']: {
                    position: 'sticky',
                    zIndex: theme.zIndex.default
                },
                ['&[data-sticky-vertical=true]']: {
                    top: 0,
                    ['&:after']: {
                        content: '""',
                        position: 'absolute',
                        transition: transition({
                            attributes: [
                                'opacity'
                            ]
                        }),
                        opacity: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        height: 2,
                        backgroundColor: theme.color.border20
                    },
                    ['&[data-scrolled-vertical=true]:after']: {
                        opacity: 1
                    }
                },
                ['&[data-sticky-horizontal=true]']: {
                    left: 0,
                    ['&:before']: {
                        content: '""',
                        position: 'absolute',
                        transition: transition({
                            attributes: [
                                'opacity'
                            ]
                        }),
                        opacity: 0,
                        top: 0,
                        bottom: 0,
                        right: -4,
                        width: 4,
                        // color below should refer to a theme color but currently our theme
                        // returns the css variable (e.g. "--color-primary-action-base") making it not work with "rgba" function
                        background: `linear-gradient(
              to right,
              rgba(40, 43, 48, 0.2) 0%,
              rgba(40, 43, 48, 0) 100%
            );`
                    },
                    ['&[data-scrolled-horizontal=true]:before']: {
                        opacity: 1
                    }
                }
            }, params.cellBorders && {
                borderRight: `1px solid ${theme.color.border20}`,
                ['&:first-of-type']: {
                    borderLeft: `1px solid ${theme.color.border20}`
                }
            }, params.withSeparateRows && {
                borderTop: `1px solid ${theme.color.border20}`,
                borderBottom: `1px solid ${theme.color.border20}`,
                ['&:nth-of-type(1)']: {
                    borderLeft: `1px solid ${theme.color.border20}`,
                    borderTopLeftRadius: theme.space.s,
                    borderBottomLeftRadius: theme.space.s
                },
                ['&:last-child']: {
                    borderRight: `1px solid ${theme.color.border20}`,
                    borderTopRightRadius: theme.space.s,
                    borderBottomRightRadius: theme.space.s
                }
            }),
            // header cells
            ['& th']: _object_spread(_object_spread_props(_object_spread({
                backgroundColor: params.kind === 'primary' ? theme.color.backgroundSecondary : theme.color.backgroundPrimary,
                fontWeight: theme.fontWeight.bold,
                textTransform: 'uppercase',
                fontSize: theme.textSize.xs,
                verticalAlign: 'bottom',
                color: theme.color.textSecondary,
                whiteSpace: 'nowrap',
                textAlign: 'left',
                WebkitFontSmoothing: 'antialiased'
            }, params.cellBorders && {
                borderTop: `1px solid ${theme.color.border20}`
            }), {
                ['&[data-highlighted=true]']: {
                    backgroundColor: theme.color.grayscale20,
                    color: theme.color.textPrimary
                },
                // weird fix to make sticky cells not overlap eachother
                ['&[data-sticky=true]']: {
                    zIndex: theme.zIndex.default + 1,
                    ['&:first-of-type']: {
                        zIndex: theme.zIndex.default + 2
                    }
                }
            }), isStriped && {
                ['&:first-of-type']: _object_spread({
                    borderTopLeftRadius: theme.space.s,
                    borderBottomLeftRadius: theme.space.s
                }, isStriped && isGrouped && {
                    paddingLeft: '0 !important'
                }),
                ['&:last-of-type']: {
                    borderTopRightRadius: theme.space.s,
                    borderBottomRightRadius: theme.space.s
                }
            }, isStriped && isGrouped && {
                paddingBottom: theme.space.s
            }),
            ['& tr']: _object_spread({
                borderBottom: !isStriped ? `1px solid ${theme.color.border20}` : undefined
            }, isStriped && {
                [`&:nth-of-type(${oddOrEven})`]: {
                    ['td']: _object_spread({
                        background: theme.color.backgroundSecondary,
                        border: 'none !important'
                    }, !isGrouped && {
                        ['&:nth-of-type(1)']: {
                            borderTopLeftRadius: theme.space.s,
                            borderBottomLeftRadius: theme.space.s
                        },
                        ['&:last-child']: {
                            borderTopRightRadius: theme.space.s,
                            borderBottomRightRadius: theme.space.s
                        }
                    })
                }
            })
        }), isGrouped && {
            ['tbody']: {
                ['& tr']: {
                    ['& td']: _object_spread_props(_object_spread({}, !isStriped && {
                        borderBottom: `1px solid ${theme.color.backgroundSecondary}`
                    }), {
                        ['&:nth-of-type(1)']: {
                            borderLeft: `1px solid ${theme.color.backgroundSecondary}`
                        },
                        ['&:last-child']: {
                            borderRight: `1px solid ${theme.color.backgroundSecondary}`
                        }
                    }),
                    ['&:nth-of-type(1)']: {
                        ['& td']: {
                            borderTop: `1px solid ${theme.color.backgroundSecondary}`
                        },
                        ['& td:nth-of-type(1)']: {
                            borderTop: `1px solid ${theme.color.backgroundSecondary}`,
                            borderTopLeftRadius: theme.space.s
                        },
                        ['& td:last-child ']: {
                            borderTop: `1px solid ${theme.color.backgroundSecondary}`,
                            borderTopRightRadius: theme.space.s
                        }
                    },
                    ['&:last-child']: {
                        ['& td']: {
                            borderBottom: `1px solid ${theme.color.backgroundSecondary}`
                        },
                        ['& td:nth-of-type(1)']: {
                            borderBottomLeftRadius: theme.space.s
                        },
                        ['& td:last-child ']: {
                            borderBottomRightRadius: theme.space.s
                        }
                    }
                }
            }
        }), {
            ['& thead[data-trailing-border-bottom=none] tr:last-of-type, & tbody[data-trailing-border-bottom=none] tr:last-of-type, tr[data-trailing-border-bottom=none]']: {
                borderBottom: 'none'
            },
            // highlighted row gets same border as hover effect
            ['& tr[data-highlighted=true] td:first-of-type']: {
                boxShadow: `inset 2px 0px 0px ${theme.color.primaryActionBase}`
            }
        }), params.withHover && {
            ['& td']: {
                cursor: 'pointer'
            },
            ['& tr:hover td:first-of-type']: {
                boxShadow: `inset 2px 0px 0px ${theme.color.primaryActionBase}`
            }
        })
    };
});
